
<header class="main-header">
    <a routerLink="/" class="logo">
       <span class="logo-mini">
        <img  alt="" src="assets/images/LBsofter-small-logo.svg">
       </span>        
       <span class="logo-lg">
        <img src="assets/images/LBSofter-Logo.svg" alt="">
       </span>
    </a>
    <nav class="navbar navbar-static-top"> 
        <h2 class="app-brand">
            <a href="" class="sidebar-toggle" (click)="addBodyClass($event)">
                <img src="assets/images/nav-icon.svg" alt="">
            </a>
        </h2>
        <div class="user-dropdown">
            <a href="3" class="user-info-link" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="profile-pic"><!--bindings={
                    "ng-reflect-ng-if": "true"
                  }--><div class="ng-star-inserted">
                  <!----></div>
                </div>
                <div class="user-dropdown-detail">
                    <span  class="user-name">{{tokenData.firstName}} {{tokenData.lastName}}</span>
                </div>
                <i class="fa fa-angle-down"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-end drop-listing">
                <li><a href="javascript:void(0)" class="dropdown-item" (click)="logout()"> <i class="logout"></i> Logout</a></li>
            </ul>
        </div>
    </nav>
</header>